import util from '@bmp-vue/core/api/util'
const controller = 'Magalupay'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Autenticar: function (token, cpf, email, nome) {
    return util.Axios.Post(controller + '/AccessToken', { token, cpf, email, nome })
  },
  ValidaCPF: function (cpf) {
    return util.Axios.Post(controller + '/ValidaCPF', { cpf })
  },
  GetEmail: function () {
    return util.Axios.Get(controller + '/GetEmail')
  },
  GetCPF: function () {
    return util.Axios.Get(controller + '/GetCPF')
  },
  GetDocumento: function () {
    return util.Axios.Get(controller + '/GetDocumento')
  },
  GetDadosBancarios: function () {
    return util.Axios.Get(controller + '/GetDadosBancarios')
  },
  ValidaTelefone: function (telefone) {
    return util.Axios.Post(controller + '/ValidaTelefone', { telefone })
  },
  AtualizaDadosCliente: function (dto) {
    return util.Axios.Post(controller + '/AtualizaDadosCliente', dto)
  },
  EnviarRequisicaoCAF: function (level) {
    return util.Axios.Post(controller + '/EnviarRequisicaoCAF/' + level)
  },
  AtualizarProposta: function (token) {
    return util.Axios.Post(controller + '/AtualizarProposta/' + token)
  }
})
